import React, { useContext, useEffect, useState } from 'react'
import { fetchRoleCodeDetail } from '../services'
import { MyContext } from '..'

export default function Calendar(props) {
  const [role, setRole] = useState("")
  const { backendUrl } = useContext(MyContext)

  useEffect(() => {
    async function fetchData() {
      const data = await fetchRoleCodeDetail(backendUrl, props.roleCode)
      setRole(data.data.name?.toLowerCase())
    }
    fetchData()
  }, [backendUrl, props.roleCode])
  return (
    <div>
      <iframe title="calendar" src={`https://elearning.virtusasystems.com/calendar/${role}/${props.subCode}/${props.username}`} frameborder="0" style={{ width: "100vw", height: "90vh" }}></iframe>
    </div>
  )
}